import React, { useEffect, useRef, useState } from 'react';

import { BarTask } from '@interfaces/ganttTasks/barTask';
import { Task } from '@interfaces/ganttTasks/ganttTasks';

import styles from './Tooltip.module.scss';

export type TooltipProps = {
	task: BarTask;
	arrowIndent: number;
	svgContainerHeight: number;
	svgContainerWidth: number;
	svgWidth: number;
	headerHeight: number;
	taskListWidth: number;
	scrollX: number;
	scrollY: number;
	rowHeight: number;
	TooltipContent: React.FC<{
		task: Task;
	}>;
};

const Tooltip: React.FC<TooltipProps> = ({
	task,
	rowHeight,
	svgContainerHeight,
	svgContainerWidth,
	scrollX,
	scrollY,
	arrowIndent,
	headerHeight,
	taskListWidth,
	TooltipContent,
}) => {
	const tooltipRef = useRef<HTMLDivElement | null>(null);
	const [relatedY, setRelatedY] = useState(0);
	const [relatedX, setRelatedX] = useState(0);

	useEffect(() => {
		if (tooltipRef.current) {
			const tooltipHeight = tooltipRef.current.offsetHeight * 1.1;
			const tooltipWidth = tooltipRef.current.offsetWidth * 1.1;

			let newRelatedY = task.index * rowHeight - scrollY + headerHeight;
			let newRelatedX: number;

			newRelatedX = task.x2 + arrowIndent * 1.5 + taskListWidth - scrollX;
			const tooltipLeftmostPoint = tooltipWidth + newRelatedX;
			const fullChartWidth = taskListWidth + svgContainerWidth;
			if (tooltipLeftmostPoint > fullChartWidth) {
				newRelatedX =
					task.x1 +
					taskListWidth -
					arrowIndent * 1.5 -
					scrollX -
					tooltipWidth;
			}
			if (newRelatedX < taskListWidth) {
				newRelatedX = svgContainerWidth + taskListWidth - tooltipWidth;
				newRelatedY += rowHeight;
			}

			const tooltipLowerPoint = tooltipHeight + newRelatedY - scrollY;
			if (tooltipLowerPoint > svgContainerHeight - scrollY) {
				newRelatedY = svgContainerHeight - tooltipHeight;
			}
			setRelatedY(newRelatedY);
			setRelatedX(newRelatedX);
		}
	}, [
		tooltipRef,
		task,
		arrowIndent,
		scrollX,
		scrollY,
		headerHeight,
		taskListWidth,
		rowHeight,
		svgContainerHeight,
		svgContainerWidth,
	]);

	return (
		<div
			ref={tooltipRef}
			className={
				relatedX
					? styles.tooltipDetailsContainer
					: styles.tooltipDetailsContainerHidden
			}
			style={{ left: relatedX, top: relatedY }}
		>
			<TooltipContent task={task} />
		</div>
	);
};

export default Tooltip;
